import { LineChart, Line, BarChart, Bar, ResponsiveContainer } from 'recharts';

interface Props {
  value: number[] | null | undefined;
  type?: 'line' | 'bar';
  color?: string;
}

export function SparklineCellRenderer({ value, type = 'line', color = '#0f172a' }: Props) {
  if (!value || value.length === 0) {
    return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  }
  const data = value.map((v, i) => ({ i, v }));
  return (
    <div data-testid="sparkline" style={{ width: '100%', height: 24 }}>
      <ResponsiveContainer width="100%" height="100%">
        {type === 'bar' ? (
          <BarChart data={data}>
            <Bar dataKey="v" fill={color} radius={[1, 1, 0, 0]} />
          </BarChart>
        ) : (
          <LineChart data={data}>
            <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} dot={false} />
          </LineChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
